import React from 'react';

function Header({ menuOpen, setMenuOpen }) {
  return (
    <header className="bg-cream-dark border-b border-red-800/20 sticky top-0 z-50 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center text-[#3E1F14]">
        <div className="text-2xl font-extrabold tracking-tight">Pecel Madiun</div>

        <button
          className="md:hidden text-red-800"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <nav className="hidden md:flex gap-8 font-medium">
          <a href="#home" className="text-[#5A2A1B] hover:text-primary transition">Home</a>
          <a href="#story" className="text-[#5A2A1B] hover:text-primary transition">Story</a>
          <a href="#menu" className="text-[#5A2A1B] hover:text-primary transition">Menu</a>
          <a href="#contact" className="text-[#5A2A1B] hover:text-primary transition">Visit</a>
        </nav>
      </div>

      {menuOpen && (
        <nav className="md:hidden bg-cream px-4 py-4 space-y-2">
          <a href="#home" className="block text-[#5A2A1B] hover:text-primary py-2 transition">Home</a>
          <a href="#story" className="block text-[#5A2A1B] hover:text-primary py-2 transition">Story</a>
          <a href="#menu" className="block text-[#5A2A1B] hover:text-primary py-2 transition">Menu</a>
          <a href="#contact" className="block text-[#5A2A1B] hover:text-primary py-2 transition">Visit</a>
        </nav>
      )}
    </header>
  );
}

export default Header;
